<template>
  <div class="wrapper">
    <ifaramepage-header></ifaramepage-header>
    <router-view :key="$router.currentRoute.fullPath"></router-view>
    <iframepage-footer></iframepage-footer>
  </div>
</template>

<script>
import IfaramepageHeader from './components/Header.vue'
import IframepageCarousel from './components/Carousel.vue'
import IframepageFooter from './components/Fotter.vue'
export default {
  name:'Iframepage',
  components: {
    IfaramepageHeader,
    IframepageFooter,
    IframepageCarousel
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/iframepage/Iframepage.vue